import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { ZH_TRANSLATE } from "@/data/zh-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/zh/translate";
const C = ZH_TRANSLATE;

export const Route = createFileRoute("/zh/translate")({
  head: () => ({
    meta: [
      { title: ctaTitle("曼谷中文翻译公证 ↔ 泰文 / 英文 | NYC Legal (中文)", "/zh/translate", "th")},
      { name: "description", content: ctaDesc("曼谷专业中文 ↔ 泰文 / 英文翻译公证。MOJ 注册译员,翻译公司印章齐备。法律、移民、教育、商业文件。. Get your timeline and checklist in minutes — chat now.", "/zh/translate", "th")},
      { property: "og:title", content: ctaTitle("中泰翻译公证 (中文) | NYC Legal", "/zh/translate", "th")},
      { property: "og:description", content: ctaDesc("MOJ 注册译员中泰翻译;可加公证 + Apostille。微信报价 30 分钟。", "/zh/translate", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "zh_CN" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/translate" },
          { hreflang: "en", path: "/en/translate" },
          { hreflang: "zh", path: "/zh/translate" },
          { hreflang: "x-default", path: "/translate" },
        ],
        "/translate",
      ),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          name: "NYC Legal — 中文翻译公证",
          url: `${SEO_SITE}${PATH}`,
          areaServed: "TH",
          inLanguage: "zh",
          priceRange: "฿500–฿3,000",
          serviceType: "Certified Translation Chinese-Thai-English",
          provider: { "@type": "ProfessionalService", name: "NYC Language Institute", url: SEO_SITE },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "zh",
          mainEntity: C.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: `${SEO_SITE}/zh` },
            { "@type": "ListItem", position: 2, name: "翻译", item: `${SEO_SITE}${PATH}` },
          ],
        }),
      },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
